import { getValueAtPath, withProperties } from "../../utils";

export default function state() {
    const NAME = 'isTestMode';
    const $state = Object.create(null);
    const { data } = this;

    function Reducer() {
        return __getTestModeStatus__();
    }

    withProperties($state, {
        NAME,
        Reducer
    })

    function __getTestModeStatus__() {
        const publicKey = getValueAtPath(data, 'PBFPubKey')
        return publicKey ? publicKey.includes('_TEST') : false;
    }

    return (state = $state)
}